import { cn } from '@seen/ui'
import DOMPurify from 'dompurify'
import type { JSX } from 'react'

export interface SanitizedHTMLProps {
  htmlString: string
  className?: string
  inline?: boolean
}

export function SanitizedHTML({
  htmlString,
  className,
  inline = false,
}: SanitizedHTMLProps): JSX.Element {
  const Component = inline ? 'span' : 'div'
  let sanitized = DOMPurify.sanitize(htmlString)
  if (inline) {
    sanitized = sanitized.replace(/<\/?p>/g, '').replace(/<br\s*\/?>/g, ' ')
  }

  return (
    <Component
      className={cn(className)}
      dangerouslySetInnerHTML={{ __html: sanitized }}
      title={sanitized}
    />
  )
}
